//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"ConstraintPoint",1,"Point",0],[1,"PointSelection",0,"SelectNXObject",0]],[[["point_type","base_point","offset_dir","offset_expression"],"GetPointData",{},0,0],[[],"GetStockOffsetPointObject",{R_:{offsetObject:"TaggedObject"}},0,0]],[]];
SPLM.Routing.StockOffsetPointBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.StockOffsetPointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.StockOffsetPointBuilder.PointType = Object.freeze({
    "Normal" : "Normal", "StockOffset" : "StockOffset"});

export default SPLM;